import React, { useEffect, useState } from "react";
import Login from "./pages/Login";
import {
  getAccessToken,
  isAccessTokenValid,
  refreshAccessToken,
  clearAuth,
} from "./apiAuth";

const PUBLIC_PATHS = ["/singin", "/login"];

const normalizePath = (path) => {
  if (!path) return "/";
  if (path.length > 1 && path.endsWith("/")) {
    return path.slice(0, -1);
  }
  return path;
};

const AuthGate = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  const currentPath = normalizePath(window.location.pathname);
  const isPublicPath = PUBLIC_PATHS.includes(currentPath);

  useEffect(() => {
    let cancelled = false;

    const finish = (isAllowed) => {
      if (!cancelled) {
        setAllowed(isAllowed);
        setChecking(false);
      }
    };

    const checkAuth = async () => {
      const access = getAccessToken();

      if (access && isAccessTokenValid(access)) {
        finish(true);

        if (isPublicPath) {
          window.location.replace("/");
        }

        return;
      }

      const newAccess = await refreshAccessToken();

      if (newAccess) {
        finish(true);

        if (isPublicPath) {
          window.location.replace("/");
        }

        return;
      }

      clearAuth();
      finish(false);

      if (!isPublicPath) {
        window.location.replace("/singin");
      }
    };

    checkAuth();

    return () => {
      cancelled = true;
    };
  }, [currentPath, isPublicPath]);

  if (checking) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f6eee8",
          color: "#4b2e20",
          fontWeight: 700,
        }}
      >
        Checking secure session...
      </div>
    );
  }

  if (!allowed) {
    return <Login />;
  }

  return children;
};

export default AuthGate;
